import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";

import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
import {
  AllInstrumentMaintance,
  AllPaymentMethod,
  AllTestMethod,
} from "../../../features/admin/common/Slice";
import "./instrument_maintance.css";
import Success_Toster from "../success_toster/Success_Toster";
import { SampleInvoiceGenerate } from "../../../features/admin/customer_management/Slice";
import { GetAllInstrument, InstrumentMaintanceUpdate } from "../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import Error_Toster from "../error_toster/Error_Toster";

const Instrument_Maintance = ({
  id,
  selectedRows,
  show,
  onHide,
  modalHeadingText,
  imgSrc,
  btnText,
  data,
}) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const all_instrument_maintence = useSelector(
    (state) => state.common.all_instrument_maintence,
  );
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  useEffect(() => {
    dispatch(AllInstrumentMaintance());
  }, [dispatch]);

  const onSubmit = async (d) => {
    try {
      const sendData = new FormData();

      sendData.append(
        "maintenance_check_point_id",
        d?.maintenance_check_point_id?.value,
      );

      const res = await dispatch(
        InstrumentMaintanceUpdate({ id: data?.id, sendData }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        console.log(res, "res res res");
        setSuccess(true);
        setErrorMessage(false);
        await dispatch(GetAllInstrument({}));
        setTimeout(() => {
          setSuccess(false);
          onHide();
        }, 2000);
      } else {
        setErrorMessage(res.payload.errors);

        setTimeout(() => {
          setErrorMessage(false);
          onHide();
        }, 2000);
        // setSuccess(true);
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  return (
    <Modal
      className="common_modal Certification_Modal"
      centered
      show={show}
      onHide={onHide}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="back_div" onClick={onHide}>
            <Common_Back_Btn backText="Maintenance Status" />
          </div>
          {modalHeadingText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Instrument Maintenance</Form.Label>

            <Controller
              className="select-contoller"
              name={`maintenance_check_point_id`} // name of the field
              control={control}
              rules={{
                required: "Select Payment Method",
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: errors?.maintenance_check_point_id
                        ? "red"
                        : baseStyles.borderColor,
                    }),
                  }}
                  options={all_instrument_maintence}
                  onChange={(selectedValue) => {
                    onChange(selectedValue);
                  }}
                  onBlur={onBlur}
                  value={value}
                  ref={ref}
                />
              )}
            />

            {errors.maintenance_check_point_id && (
              <Form.Text className="text-danger">
                {errors.maintenance_check_point_id.message}
              </Form.Text>
            )}
          </Form.Group>

          <div className="btn_holder text-end">
            <Black_Submit_Btn btnText={btnText || "Submit"} type="submit" />
          </div>
        </Form>
      </Modal.Body>
      {success && (
        <Success_Toster successText={"Status Updated Successfully!"} />
      )}

      {errorMessage && (
        <Error_Toster successText={errorMessage || "Something Went Wrong!"} />
      )}
    </Modal>
  );
};

export default Instrument_Maintance;
